export default __webpack_public_path__ + "static/media/cbn.e52d0300.jpeg";